import FooterPage from "../components/Custom/Footer/FooterPage";
import Navbar from "../components/Custom/Navbar/Navbar";
import Contact from "../components/Home/Contact/Contact";
import CoupleSection from "../components/Home/CoupleSection/CoupleSection";
import Header from "../components/Home/Header/Header";
import Questions from "../components/Home/Questions/Questions";
import WeAre from "../components/Home/WeAre/WeAre";

export default function Home() {
  return (
    <>
      <Navbar />
      <Header />
      <CoupleSection />
      <WeAre />
      <Questions />
      <Contact />
      <FooterPage />
    </>
  );
}
